import { ImageObject, Person, WithContext } from "schema-dts";

export const generatePersonSchema = (person: {
  name: string;
  image?: ImageObject | string | string[];
  url?: string;
  sameAs?: string[];
  description?: string;
  role?: string;
}): WithContext<Person> => {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: person.name,
    image: person.image,
    url: person.url,
    jobTitle: person.role,
    sameAs: person.sameAs,
    description: person.description,
  };
};
